import { IProductParameter } from '../dataModels/ProductModels';
import * as style from './style.css';
import * as prodStyle from '../style.css';
import React = require('react');

interface IProps {
    parameters: IProductParameter[];
}
interface IState {
}

export default class ModelParameters extends React.Component<IProps, IState> {
    render() {
        return (
            <div className={style.parametersWrapper}>
                <div className={style.parameters}>
                    {this.props.parameters.filter(p => p.groupName !== 'Przeliczniki').map((p, i) => this.parameter(p, i))}
                </div>
            </div>
        );
    }

    parameter(p: IProductParameter, index: any): any {
        return <div key={index} className={prodStyle.dataRow}>
            <div >
                {p.name}:
            </div>
            <div >
                {p.displayValue} {p.unit}
            </div>
        </div>;
    }
}
